<div *ngIf="formVisible">
  <div class="filter-container">
    <form>
      <div class="title">
        <span id="icon" class="material-icons-outlined icon-archived">
          toggle_on
        </span>
        <label for="active-filter">Active:</label>
      </div>

      <button class="apply-filter-btn" (click)="apply()">Apply</button>
    </form>
  </div>
</div>
